export function formatAddress(address) {
    if (typeof address === 'string') {
        return address.toUpperCase();
    }

    return address;
}

export function formatLastname(lastname) {
    if (typeof lastname === 'string') {
        return lastname.toUpperCase();
    }
    return lastname;
}

export function formatFirstname(firstname) {
    if (typeof firstname === 'string') {
        return firstname.charAt(0).toUpperCase() + firstname.slice(1);
    }
    return firstname;
}

export function formatCity(city) {
    if (typeof city === 'string') {
        return city.toUpperCase();
    }

    return city;
}

export function formatMobilePhone(mobilePhone) {
    if (typeof mobilePhone !== 'string') {
        return mobilePhone;
    }

    if (!mobilePhone.startsWith("+")) {
        return `+33${mobilePhone.slice(1)}`;
    }

    return mobilePhone;
}

export function formatPaymentInterval(paymentInterval) {
    switch (paymentInterval?.toLowerCase()) {
        case 'monthly':
            return 'Mensuel';
        case 'annualy':
        case 'yearly':
            return 'Annuel';
        default:
            return 'Inconnu';
    }
}

export function formatGender(gender) {

    const genders = {
        'M': 'Homme',
        'F': 'Homme',
        'O': 'Autre'
    };

    return genders[gender?.toUpperCase()] ?? gender;
}

export function formatLicensePlate(licensePlate) {
    const regexLicensePlate = /^(\d{2,3}-?[A-Z]{2}-?\d{2}|\d{3}-?[A-Z]{3}-?\d{2}|[A-Z]{1,2}-?\d{2,3}-?[A-Z]{1,3}|[A-Z]-?\d{2}-?[A-Z]{1})$/;
    
    if (regexLicensePlate.test(licensePlate)) {
        return licensePlate.replace(/^(\d{2,3}|[A-Z]{1,2})-?(\d{2,3})-?([A-Z]{1,3})$/, "$1-$2-$3");
    } else {
        return licensePlate;
    }
}